module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAACiAQMAAAC+puW3AAAAA1BMVEXOzs4V7pPnAAAADUlEQVQY02NgGAWUAgABRAABLp9H3gAAAABJRU5ErkJggg=="